import React, { createContext, useState } from 'react';

import * as api from '../../lib/api/api';

const ReviewContext = createContext();
export default ReviewContext;

const { Provider, Consumer: ReviewConsumer } = ReviewContext;

const ReviewProvider = (props) => {
  const [likeItems, setLikeItems] = useState([]);

  const onLike = async (id) => {
    await api.putReviewLike({ id });
    setLikeItems((prevState) => {
      return [...prevState, id];
    });
  };

  const onUnlike = async (id) => {
    await api.putReviewUnlike({ id });
    const nextLikeItems = likeItems.filter((item) => item !== id);
    setLikeItems(nextLikeItems);
  };

  const context = {
    state: {
      likeItems,
    },
    actions: {
      onLike,
      onUnlike,
    },
  };

  return <Provider value={context}>{props.children}</Provider>;
};

export { ReviewProvider, ReviewConsumer };
